import { Link } from 'react-router-dom'
import { LATEST_PRIVACY_VERSION } from '../content/privacy'
import { useAuthStore } from '../store/authStore'

export default function PrivacyPolicyPage() {
  const { Content, effectiveDateLabel } = LATEST_PRIVACY_VERSION
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated)
  return (
    <div className="h-screen overflow-y-auto bg-gray-50 py-8 px-4 print:h-auto print:overflow-visible print:bg-white print:py-0">
      <div className="max-w-4xl mx-auto space-y-6">
        <div className="flex items-center justify-between print:hidden">
          <Link to={isAuthenticated ? '/' : '/login'} className="inline-flex items-center text-sm text-gray-600 hover:text-brand-cyan-text">
            <svg className="w-4 h-4 mr-1.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M10 19l-7-7m0 0l7-7m-7 7h18" />
            </svg>
            {isAuthenticated ? 'Nazad na aplikaciju' : 'Nazad na prijavu'}
          </Link>
          <button onClick={() => window.print()}
            className="inline-flex items-center gap-1.5 text-xs font-medium text-gray-500 border border-gray-200 rounded-lg px-3 py-1.5 hover:text-brand-cyan-text hover:border-brand-cyan transition-colors">
            <svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M17 17h2a2 2 0 002-2v-4a2 2 0 00-2-2H5a2 2 0 00-2 2v4a2 2 0 002 2h2m2 4h6a2 2 0 002-2v-4a2 2 0 00-2-2H9a2 2 0 00-2 2v4a2 2 0 002 2zm8-12V5a2 2 0 00-2-2H9a2 2 0 00-2 2v4h10z" />
            </svg>
            Odštampaj / Sačuvaj kao PDF
          </button>
        </div>

        <div className="bg-white rounded-2xl shadow-lg border border-gray-200 p-6 sm:p-10 space-y-8 print:shadow-none print:border-0 print:p-0">
          <div>
            <div className="inline-block text-xs font-semibold uppercase tracking-wide text-brand-cyan-text bg-brand-cyan-tint px-2.5 py-1 rounded-full mb-3">
              Pravni dokument
            </div>
            <h1 className="text-2xl sm:text-3xl font-bold text-brand-midnight">Politika privatnosti</h1>
            <p className="text-sm text-gray-500 mt-1">
              Za softversku platformu i mobilnu aplikaciju <span className="font-semibold text-gray-700">waterworks.rs</span>
            </p>
          </div>

          <div className="bg-brand-ice border border-brand-cyan/30 rounded-xl p-4 text-sm space-y-1">
            <p><strong>Datum stupanja na snagu:</strong> {effectiveDateLabel}</p>
            <p><strong>Projekat:</strong> waterworks.rs (web portal i mobilna aplikacija)</p>
            <p><strong>Vlasnik softvera / Obrađivač:</strong> I-SOFT MIONICA, Kneza Jovice Milutinovića 38, 14242 Mionica (PIB: 109319817, MB: 64091034)</p>
          </div>

          <Content />
        </div>

        <div className="text-center text-xs text-gray-400 py-4 print:hidden">
          &copy; {new Date().getFullYear()} waterworks.rs — Sva prava zadržana.
        </div>
      </div>
    </div>
  )
}
